import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import { FaKaggle } from "react-icons/fa";


const SOCIAl_BUTTONS = [
  {
    href: "https://www.linkedin.com/in/mohammedshibinv",
    icon: <IoMailOutline />,
  },
  {
    href: "https://www.linkedin.com/in/mohammedshibinv",
    icon: <FaLinkedin />,
  },
  {
    href: "https://github.com/mohammedshibinv",
    icon: <FaGithub />,
  },
  {
    href: "https://www.kaggle.com/mohammedshibinv",
    icon: <FaKaggle />,
  },
];

export default SOCIAl_BUTTONS;
